import React from 'react';
import cx from 'classnames';

import IconButton from '../IconButton';
import ArrowUp from '../Icons/ArrowUp';
import ArrowDown from '../Icons/ArrowDown';
import Switch from '../Icons/Switch';

import styles from './TableHeadCell.module.scss';

export interface TableHeadCellProps
  extends React.HTMLProps<HTMLTableCellElement> {
  /** Alignment for content in table head cell. This will override the align prop value that is set in the `Table.Cell`. */
  align?: 'start' | 'center' | 'end';
  /** Child of `Table.HeadCell` which should be any element. */
  children: React.ReactNode;
  /** Disable sort for header. */
  disableSortBy?: boolean;
  /** Set the sort order for the table. */
  sort?: 'none' | 'ascending' | 'descending';
  /** Adjust the width of the table head cell. */
  width?: string | number | undefined;
}

export const TableHeadCell: React.FC<TableHeadCellProps> = ({
  children,
  align = 'start',
  disableSortBy = true,
  sort = 'none',
  width = undefined,
  className,
  ...rest
}) => (
  <th
    {...rest}
    className={cx(styles.header, align && styles[align], className)}
    style={{ width: width }}
  >
    <span className={styles.headerWrapper}>
      {align !== 'end' ? children : null}
      {disableSortBy ? null : (
        <IconButton
          className={styles.sortBtn}
          accessibilityLabel={`Toggle Sort ${typeof children === 'string' &&
            children} column, currently ${sort === 'none' ? 'unsorted' : sort}`}
          icon={
            sort !== 'none' ? (
              sort === 'descending' ? (
                <ArrowDown />
              ) : (
                <ArrowUp />
              )
            ) : (
              <Switch />
            )
          }
        />
      )}
      {align === 'end' ? children : null}
    </span>
  </th>
);

export default TableHeadCell;
export { styles };
